<app-public-toolbar></app-public-toolbar>

<main class="min-w-0 w-full overflow-x-hidden">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
